var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3204",
    "data-name": "Group 3204",
    transform: "translate(-449 -150)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_398",
    "data-name": "Rectangle 398",
    width: 32,
    height: 20,
    transform: "translate(449 150)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mastercard",
    transform: "translate(452 51.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M217.591,108.8a8,8,0,1,1-15.991,0h0a8,8,0,1,1,15.991,0Z",
    transform: "translate(-191.591 0)",
    fill: "#ff8500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M209.6,100.8a8.019,8.019,0,0,1,8,8h0a8,8,0,1,1-15.991,0",
    transform: "translate(-191.591 0)",
    fill: "#ff8500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M352.8,100.8a8.019,8.019,0,0,1,8,8h0a7.991,7.991,0,0,1-8,8",
    transform: "translate(-334.796 0)",
    fill: "#ff8500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M7.911,100.8A8,8,0,0,0,8,116.8a8.086,8.086,0,0,0,5.373-2.074h0a7.6,7.6,0,0,0,.8-.847h-1.65a9.767,9.767,0,0,1-.592-.8h2.834a5.423,5.423,0,0,0,.465-.847H11.465a5.046,5.046,0,0,1-.338-.847h4.4a8.409,8.409,0,0,0,.423-2.54,10.931,10.931,0,0,0-.169-1.693H10.872a6.192,6.192,0,0,1,.212-.847h4.4a5.046,5.046,0,0,0-.338-.847H11.422a8.4,8.4,0,0,1,.465-.847h2.834a4.025,4.025,0,0,0-.635-.847H12.522a7.212,7.212,0,0,1,.8-.8,7.8,7.8,0,0,0-5.373-2.074C7.953,100.8,7.953,100.8,7.911,100.8Z",
    transform: "translate(0 0)",
    fill: "#cb2026"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M0,110.315a7.991,7.991,0,0,0,8,8,8.086,8.086,0,0,0,5.373-2.074h0a7.605,7.605,0,0,0,.8-.847h-1.65a9.764,9.764,0,0,1-.592-.8h2.834a5.423,5.423,0,0,0,.465-.847H11.465a5.046,5.046,0,0,1-.338-.847h4.4a8.409,8.409,0,0,0,.423-2.54,10.931,10.931,0,0,0-.169-1.693H10.872a6.191,6.191,0,0,1,.212-.847h4.4a5.046,5.046,0,0,0-.338-.847H11.422a8.394,8.394,0,0,1,.465-.847h2.834a4.025,4.025,0,0,0-.635-.847H12.522a7.212,7.212,0,0,1,.8-.8A7.8,7.8,0,0,0,7.953,102.4H7.911",
    transform: "translate(0 -1.515)",
    fill: "#cb2026"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M149.685,118.4a8.062,8.062,0,0,0,5.373-2.085h0a7.633,7.633,0,0,0,.8-.851h-1.65a9.815,9.815,0,0,1-.592-.809h2.834a5.46,5.46,0,0,0,.465-.851h-3.765a5.088,5.088,0,0,1-.338-.851h4.4a8.494,8.494,0,0,0,.423-2.553,11.048,11.048,0,0,0-.169-1.7h-4.907a6.25,6.25,0,0,1,.212-.851h4.4a5.089,5.089,0,0,0-.338-.851h-3.723a8.448,8.448,0,0,1,.465-.851h2.834a4.044,4.044,0,0,0-.635-.851h-1.565a7.228,7.228,0,0,1,.8-.809,7.781,7.781,0,0,0-5.373-2.085H149.6",
    transform: "translate(-141.966 -1.6)",
    fill: "#cb2026"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3088",
    "data-name": "Group 3088",
    transform: "translate(0.761 106.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M182.827,223.723l.127-.719a1.834,1.834,0,0,1-.212.042c-.3,0-.338-.169-.3-.254l.254-1.481h.465l.127-.8h-.423l.085-.508h-.846s-.508,2.792-.508,3.131a.635.635,0,0,0,.677.719A1.3,1.3,0,0,0,182.827,223.723Z",
    transform: "translate(-173.004 -219.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M210.4,230.608a1.346,1.346,0,0,0,1.481,1.481,2.2,2.2,0,0,0,.888-.127l.169-.8a2.536,2.536,0,0,1-.888.212c-.931,0-.761-.677-.761-.677h1.734a5.485,5.485,0,0,0,.127-.761,1.146,1.146,0,0,0-1.227-1.227C211.035,228.619,210.4,229.55,210.4,230.608Zm1.481-1.227c.465,0,.381.55.381.592h-.931C211.331,229.931,211.415,229.381,211.881,229.381Z",
    transform: "translate(-200.337 -227.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M298.327,216.9l.169-.931a2.079,2.079,0,0,1-.719.212c-.592,0-.846-.465-.846-.973,0-1.015.508-1.565,1.1-1.565a1.413,1.413,0,0,1,.762.254l.127-.888a2.975,2.975,0,0,0-.973-.212c-.973,0-1.946.846-1.946,2.454,0,1.058.508,1.777,1.523,1.777A3.8,3.8,0,0,0,298.327,216.9Z",
    transform: "translate(-281.546 -212.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M88.008,227.2a3,3,0,0,0-1.015.169l-.127.719a2.5,2.5,0,0,1,.931-.169c.3,0,.55.042.55.3,0,.169-.042.212-.042.212h-.381c-.719,0-1.523.3-1.523,1.269,0,.761.508.931.8.931a1.271,1.271,0,0,0,.888-.381l-.042.338h.761l.338-2.327A1,1,0,0,0,88.008,227.2Zm.169,1.9c0,.127-.085.8-.592.8a.33.33,0,0,1-.338-.338c0-.212.127-.508.761-.508A.667.667,0,0,0,88.177,229.1Z",
    transform: "translate(-82.703 -226.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M136.173,229.869a1.084,1.084,0,0,0,1.269-1.1c0-1.058-1.015-.846-1.015-1.269,0-.212.169-.3.465-.3.127,0,.592.042.592.042l.127-.761a3.213,3.213,0,0,0-.8-.085c-.635,0-1.269.254-1.269,1.1,0,.973,1.058.888,1.058,1.269,0,.254-.3.3-.508.3a2.766,2.766,0,0,1-.761-.127l-.127.761C135.242,229.784,135.454,229.869,136.173,229.869Z",
    transform: "translate(-128.995 -225.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M429.611,214.4l-.169,1.142a1.173,1.173,0,0,0-.8-.423c-.761,0-1.438.931-1.438,2.031,0,.677.338,1.4,1.058,1.4a1.129,1.129,0,0,0,.8-.338l-.042.3h.846l.635-4.061Zm-.381,2.242c0,.465-.212,1.058-.677,1.058-.3,0-.465-.254-.465-.677,0-.677.3-1.1.677-1.1C429.061,215.923,429.231,216.134,429.231,216.642Z",
    transform: "translate(-406.023 -214.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M15.2,218.461l.508-3.046.085,3.046h.592l1.1-3.046-.465,3.046h.888l.677-4.061h-1.4l-.846,2.5-.042-2.5H15.077l-.677,4.061Z",
    transform: "translate(-14.4 -214.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M260.891,232.1c.243-1.4.283-2.538.85-2.327a3.426,3.426,0,0,1,.284-.973h-.162c-.364,0-.648.508-.648.508l.081-.465h-.77l-.526,3.3h.891Z",
    transform: "translate(-247.38 -227.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M348.008,227.2a3,3,0,0,0-1.015.169l-.127.719a2.5,2.5,0,0,1,.931-.169c.3,0,.55.042.55.3,0,.169-.042.212-.042.212h-.381c-.719,0-1.523.3-1.523,1.269,0,.761.508.931.8.931a1.271,1.271,0,0,0,.888-.381l-.042.338h.762l.338-2.327A.988.988,0,0,0,348.008,227.2Zm.212,1.9c0,.127-.085.8-.592.8a.33.33,0,0,1-.338-.338c0-.212.127-.508.761-.508C348.177,229.1,348.177,229.1,348.219,229.1Z",
    transform: "translate(-329.355 -226.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M395.282,232.1c.24-1.4.281-2.538.842-2.327a3.457,3.457,0,0,1,.281-.973h-.16c-.361,0-.641.508-.641.508l.08-.465h-.762l-.521,3.3h.882Z",
    transform: "translate(-374.846 -227.954)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3089",
    "data-name": "Group 3089",
    transform: "translate(0.761 106.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M180,223.131a.635.635,0,0,0,.677.719,1.61,1.61,0,0,0,.635-.127l.127-.719a1.832,1.832,0,0,1-.212.042c-.3,0-.338-.169-.3-.254l.254-1.481h.465l.127-.8h-.423l.085-.508",
    transform: "translate(-171.487 -219.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M218.4,230.608c0,1.185.381,1.481,1.058,1.481a2.2,2.2,0,0,0,.888-.127l.169-.8a2.536,2.536,0,0,1-.888.212c-.931,0-.761-.677-.761-.677H220.6a5.485,5.485,0,0,0,.127-.761A1.146,1.146,0,0,0,219.5,228.7C218.612,228.619,218.4,229.55,218.4,230.608Zm1.058-1.227c.465,0,.55.55.55.592h-1.1C218.908,229.931,218.992,229.381,219.458,229.381Z",
    transform: "translate(-207.921 -227.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M305.9,216.9l.169-.931a2.079,2.079,0,0,1-.719.212c-.592,0-.846-.465-.846-.973,0-1.015.508-1.565,1.1-1.565a1.413,1.413,0,0,1,.761.254l.127-.888a2.974,2.974,0,0,0-.973-.212c-.973,0-1.523.846-1.523,2.454,0,1.058.085,1.777,1.1,1.777A3.8,3.8,0,0,0,305.9,216.9Z",
    transform: "translate(-289.127 -212.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M86.865,229.646a2.5,2.5,0,0,1,.931-.169c.3,0,.55.042.55.3,0,.169-.042.212-.042.212h-.381c-.719,0-1.523.3-1.523,1.269,0,.761.508.931.8.931a1.271,1.271,0,0,0,.888-.381l-.042.338h.761l.338-2.327c0-.973-.846-1.015-1.185-1.015m.635,1.819a1.385,1.385,0,0,1-1.015.8.33.33,0,0,1-.338-.338c0-.212.127-.508.761-.508A3.456,3.456,0,0,0,88.6,230.619Z",
    transform: "translate(-82.703 -227.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M136,229.784a3.581,3.581,0,0,0,.973.085,1.084,1.084,0,0,0,1.269-1.1c0-1.058-1.015-.846-1.015-1.269,0-.212.169-.3.465-.3.127,0,.592.042.592.042l.127-.761a3.213,3.213,0,0,0-.8-.085c-.635,0-.846.254-.846,1.1,0,.973.635.888.635,1.269,0,.254-.3.3-.508.3",
    transform: "translate(-129.754 -225.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M436.964,216.3a1.173,1.173,0,0,0-.8-.423c-.761,0-1.015.931-1.015,2.031,0,.677-.085,1.4.635,1.4a1.129,1.129,0,0,0,.8-.338l-.042.3h.846l.635-4.061m-1.1,2.2c0,.465-.381,1.058-.846,1.058-.3,0-.465-.254-.465-.677,0-.677.3-1.1.677-1.1A.646.646,0,0,1,436.922,217.4Z",
    transform: "translate(-413.545 -215.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M15.2,218.461l.508-3.046.085,3.046h.592l1.1-3.046-.465,3.046h.888l.677-4.061H17.531l-1.185,2.5-.042-2.5h-.465L14.4,218.461Z",
    transform: "translate(-14.4 -214.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M346.865,229.646a2.5,2.5,0,0,1,.931-.169c.3,0,.55.042.55.3,0,.169-.042.212-.042.212h-.381c-.719,0-1.523.3-1.523,1.269,0,.761.508.931.8.931a1.271,1.271,0,0,0,.888-.381l-.042.338h.762l.338-2.327c0-.973-.846-1.015-1.184-1.015m.635,1.819a1.385,1.385,0,0,1-1.015.8.33.33,0,0,1-.338-.338c0-.212.127-.508.761-.508A3.721,3.721,0,0,0,348.6,230.619Z",
    transform: "translate(-329.355 -227.954)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.6c9d14f3fed2337be8019e9b5b26d7c6.svg";
export { ForwardRef as ReactComponent };